import { render, staticRenderFns } from "./auditLog.vue?vue&type=template&id=ec0cbfbc&scoped=true&"
import script from "./auditLog.vue?vue&type=script&lang=js&"
export * from "./auditLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec0cbfbc",
  null
  
)

export default component.exports